import React from 'react';
import { TagShapeProps } from '../utils/common-graph.utils';
import { GRID_UNIT_SIZE } from '../utils/graph.utils';

export const LaddergramCircle: React.FC<TagShapeProps> = ({
  color,
  bordered,
  size,
}) => {
  const radius = size / 2 - GRID_UNIT_SIZE;

  return (
    <>
      {bordered && (
        <g transform={`translate(${size / 2}, ${size / 2})`}>
          <circle r={size / 2} fill='transparent' stroke='black' />
        </g>
      )}
      <g transform={`translate(${size / 2}, ${size / 2})`}>
        <circle r={radius} fill={color} />
      </g>
    </>
  );
};
